var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat-binding-index"},[(_vm.domLoad)?[_c(_vm._f("typeToComponentName")(_vm.bindingStatus),{tag:"component",attrs:{"bindingInfo":_vm.bindingInfo},on:{"bindingSuccess":_vm.bindingSuccess}})]:_vm._e(),_c('toast',{ref:"toast"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }